import { motion } from 'framer-motion';
import { useState } from 'react';
import { ChevronLeft } from 'react-feather';

export default function IconSpin({ isOpen, className }: { isOpen: boolean; className: string }) {
  const [isHovered, setIsHovered] = useState(false);

  const variants = {
    open: { rotate: 90 },
    closed: { rotate: -90 },
  };

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <motion.div
      animate={isOpen ? 'open' : 'closed'}
      className={className}
      style={{ transformOrigin: '50% 50%' }}
      transition={{ duration: 0.4, type: 'spring', stiffness: 260, damping: 15 }}
      variants={variants}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ChevronLeft size={30} />
    </motion.div>
  );
}
